<div class="card-group">
	<div><slot name="left" /></div>
	<div><slot name="right" /></div>
</div>

<style>
	.card-group {
		display: flex;
	}
	.card-group > div {
		width: 50%;
	}
	@media (max-width: 319px) {
		.card-group {
			flex-direction: column;
		}
		.card-group > div {
			width: 100%;
		}
	}
</style>
